import { render, staticRenderFns } from "./TaskChecklist.vue?vue&type=template&id=4b8bedf0&"
import script from "./TaskChecklist.vue?vue&type=script&lang=js&"
export * from "./TaskChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports